<mat-sidenav-container>
  <mat-sidenav #drawer class="sidenav" mode="over" [(opened)]="isDrawerOpen">

    <div class="position-absolute w-100 d-flex justify-content-end">
      <button type="button" mat-icon-button aria-label="Toggle sidenav"
        class="close-icon d-flex align-items-center justify-content-center zx-z-index-2" (click)="closeDrawer()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <mat-nav-list class="d-flex flex-column vh-100 pb-5">

      <div class="w-100 d-flex justify-content-center zx-z-index-1 c-pointer" (click)="goToHome()">
        <img src="assets/images/eazix-logo.png" alt="Eazix Logo" class="eazix-logo c-pointer">
      </div>

      <a class="d-md-none" mat-list-item (click)="goToNewOrder()">
        <div class="d-flex align-items-center gap-2">
          <mat-icon class="text-green zx-text-medium zx-small-tiny-plus-icon-size">add_circle_outline</mat-icon>
          <span class="mat-list-item-small text-green fw-bold">
            {{ 'main-nav.new-order' | translate }}
          </span>
        </div>
      </a>

      <div class="d-sm-none w-100 zx-border-gray-top-v-v-light my-1" [class.zx-low-opp]="isDarkMode"></div>

      <a mat-list-item (click)="goToQAndA()">
        <span class="mat-list-item-small">
          {{ 'main-nav.q-and-a' | translate }}
        </span>
      </a>

      <div class="w-100 zx-border-gray-top-v-v-light my-1" [class.zx-low-opp]="isDarkMode"></div>

      <a mat-list-item (click)="openWhatsApp()">
        <div class="w-100 h-100 d-flex align-items-center gap-2">
          <div class="whatsup-logo-container">
            <img src="assets/images/whatsup-logo.svg" alt="WhatsUp Logo" class="whatsup-logo">
          </div>
          <span class="mat-list-item-small">
            {{'main-nav.contact-us' | translate}}
          </span>
        </div>
      </a>

      <div class="w-100 zx-border-gray-top-v-v-light my-1" [class.zx-low-opp]="isDarkMode"></div>

      <a mat-list-item (click)="openByPrinterNumberDialog()">
        <span class="mat-list-item-small">
          {{ 'by-p-num.title' | translate }}
        </span>
      </a>

      <div class="w-100 zx-border-gray-top-v-v-light my-1" [class.zx-low-opp]="isDarkMode"></div>

      <a mat-list-item (click)="goToAboutUs()">
        <span class="mat-list-item-small">
          {{ 'about-us.title' | translate }}
        </span>
      </a>

      <!-- // -->
      <div *ngIf="isSU" class="w-100 zx-border-gray-top-v-v-light my-1" [class.zx-low-opp]="isDarkMode"></div>

      <!-- Super Managment Mode -->
      <a *ngIf="isSU" mat-list-item aria-label="Super Managment" [matMenuTriggerFor]="superManigmentMode">
        <div class="d-flex align-items-center gap-2">
          <mat-icon class="c-pointer">settings</mat-icon>
          <span class="mat-list-item-small">
            {{'main-nav.super-management-mode' | translate}}
          </span>
        </div>
      </a>
      <mat-menu #superManigmentMode="matMenu" style="width: 250px;">

        <!-- printer -->
        <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
          (click)="goToManagementPage('printer')">
          <b class="zx-text-small m-0" [class.zx-text-white]="isDarkMode">
            {{ 'su-management.printer-management' | translate }}
          </b>
          <mat-icon class="mx-1 p-0 zx-pt-small" [class.zx-text-white]="isDarkMode">print</mat-icon>
        </button>
        <!-- orders -->
        <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
          (click)="goToManagementPage('orders')">
          <b class="zx-text-small m-0" [class.zx-text-white]="isDarkMode">
            {{ 'su-management.orders-management' | translate }}
          </b>
          <mat-icon class="mx-1 p-0 zx-pt-small" [class.zx-text-white]="isDarkMode">assignment</mat-icon>
        </button>
        <!-- users -->
        <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
          (click)="goToManagementPage('users')">
          <b class="zx-text-small m-0" [class.zx-text-white]="isDarkMode">
            {{ 'su-management.users-management' | translate }}
          </b>
          <mat-icon class="mx-1 p-0 zx-pt-small" [class.zx-text-white]="isDarkMode">supervisor_account</mat-icon>
        </button>
        <!-- inventory -->
        <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
          (click)="goToManagementPage('inventory')">
          <b class="zx-text-small m-0" [class.zx-text-white]="isDarkMode">
            {{ 'su-management.inventory-management' | translate }}
          </b>
          <mat-icon class="mx-1 p-0 zx-pt-small" [class.zx-text-white]="isDarkMode">ballot</mat-icon>
        </button>
        <!-- branch -->
        <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
          (click)="goToManagementPage('branch')">
          <b class="zx-text-small m-0" [class.zx-text-white]="isDarkMode">
            {{ 'su-management.branch-management' | translate }}
          </b>
          <mat-icon class="mx-1 p-0 zx-pt-small" [class.zx-text-white]="isDarkMode">how_to_reg</mat-icon>
        </button>
        <!-- report -->
        <button class="d-flex align-items-center gap-1 px-2" [class.zx-ltr]="!isRTL" mat-menu-item
          (click)="goToManagementPage('report')">
          <b class="zx-text-small m-0" [class.zx-text-white]="isDarkMode">
            {{ 'su-management.report-management' | translate }}
          </b>
          <mat-icon class="mx-1 p-0 zx-pt-small" [class.zx-text-white]="isDarkMode">equalizer</mat-icon>
        </button>

        <!-- branches -->
        <!-- <div class="d-flex p-2" [class.justify-content-end]="!isRTL">
          <u>
            {{'main-nav.super-management-branches' | translate}}
          </u>
        </div>
        <div class="d-flex" [class.flex-row-reverse]="!isRTL">
          <button class="mat-list-item-small centered-text" mat-menu-item (click)="goToBranchList()">
            <span class="zx-text-small centered-text">
              {{'choose-system.title-short-plotter' | translate}}
            </span>
          </button>
          <button class="mat-list-item-small centered-text" mat-menu-item>
            <span class="zx-text-small centered-text">
              {{'choose-system.title-short-express' | translate}}
            </span>
          </button>
        </div> -->

        <!-- users -->
        <!-- <div class="d-flex p-2" [class.justify-content-end]="!isRTL">
          <u>
            {{'main-nav.super-management-users' | translate}}
          </u>
        </div>
        <div class="d-flex" [class.flex-row-reverse]="!isRTL">
          <button class="mat-list-item-small centered-text" mat-menu-item (click)="goToUserList()">
            <span class="zx-text-small centered-text">{{'choose-system.title-short-plotter' | translate}}</span>
          </button>
          <button class="mat-list-item-small centered-text" mat-menu-item>
            <span class="zx-text-small centered-text">
              {{'choose-system.title-short-express' | translate}}
            </span>
          </button>
        </div> -->

        <!-- papers -->
        <!-- <div class="d-flex p-2" [class.justify-content-end]="!isRTL">
          <u>{{'main-nav.super-management-papers' | translate}}</u>
        </div>
        <div class="d-flex" [class.flex-row-reverse]="!isRTL">
          <button class="mat-list-item-small centered-text" mat-menu-item (click)="goToPaperList()">
            <span class="zx-text-small centered-text">
              {{'choose-system.title-short-plotter' | translate}}
            </span>
          </button>
          <button class="mat-list-item-small centered-text" mat-menu-item>
            <span class="zx-text-small centered-text">
              {{'choose-system.title-short-express' | translate}}
            </span>
          </button>
        </div> -->

        <!-- back to user mode -->
        <!-- <hr>
        <button mat-menu-item (click)="goToHome()" [class.justify-content-end]="!isRTL">
          <span class="mat-list-item-small text-green">
            {{'main-nav.user-mode' | translate}}
          </span>
        </button> -->
      </mat-menu>

      <div *ngIf="isSU" class="w-100 zx-border-gray-top-v-v-light my-1" [class.zx-low-opp]="isDarkMode"></div>

      <div class="spacer"></div>

      <!--  Set language  + Set Theme + Terms of Use + Privacy Policy -->
      <div class="w-100 d-flex flex-column align-items-center px-2 gap-2">

        <!-- Set language -->
        <button mat-flat-button aria-label="Set language" [matMenuTriggerFor]="menuLanguage"
          [matTooltip]="tooltipContentLanguage" [matTooltipPosition]="!isRTL ? 'left' : 'right'"
          class="w-100 d-flex justify-content-center align-items-center">
          <div class="w-100 d-flex align-items-center justify-content-center gap-2">
            <mat-icon>language</mat-icon>
            <span class="zx-text-tiny opacity-75">Language</span>
          </div>
        </button>
        <mat-menu #menuLanguage="matMenu">
          <button mat-menu-item (click)="goToLanguage('he')" [class.justify-content-end]="!isRTL">
            <span class="mat-list-item-small">עברית</span>
          </button>
          <button mat-menu-item (click)="goToLanguage('en')" [class.justify-content-end]="!isRTL">
            <span class="mat-list-item-small">English</span>
          </button>
          <button mat-menu-item (click)="goToLanguage('ar')" [class.justify-content-end]="!isRTL">
            <span class="mat-list-item-small">العربية</span>
          </button>
        </mat-menu>

        <!-- //  -->
        <div class="w-75 zx-border-gray-top-v-v-light pt-lg-1" [class.zx-low-opp]="isDarkMode"></div>

        <!-- Set Theme -->
        <button mat-flat-button aria-label="Set Theme" [matMenuTriggerFor]="menuTheme" [matTooltip]="tooltipContentMode"
          [matTooltipPosition]="!isRTL ? 'left' : 'right'"
          class="w-100 d-flex justify-content-center align-items-center">
          <div class="w-100 d-flex align-items-center justify-content-center gap-2">
            <mat-icon>
              {{ isDarkTheme ? 'brightness_7' : 'brightness_4' }}
            </mat-icon>
            <span class="zx-text-tiny opacity-75">
              {{'main-nav.mode' | translate}}
            </span>
          </div>
        </button>
        <mat-menu #menuTheme="matMenu">
          <button mat-menu-item (click)="changeTheme('light')" [class.justify-content-end]="!isRTL">
            <span class="mat-list-item-small">{{'main-nav.light-mode' | translate}}</span>
          </button>
          <button mat-menu-item (click)="changeTheme('dark')" [class.justify-content-end]="!isRTL">
            <span class="mat-list-item-small">{{'main-nav.dark-mode' | translate}}</span>
          </button>
        </mat-menu>

        <!-- //  -->
        <div class="w-75 zx-border-gray-top-v-v-light" [class.zx-low-opp]="isDarkMode"></div>

        <!-- Terms of Use -->
        <button mat-flat-button aria-label="Terms and Conditions" (click)="goToTandC()"
          class="w-100 d-flex justify-content-center align-items-center">
          <div class="w-100 d-flex align-items-center justify-content-center gap-1 gap-sm-2">
            <span class="zx-text-tiny opacity-75">
              {{'main-nav.t-and-c' | translate}}
            </span>
          </div>
        </button>

        <!-- //  -->
        <div class="w-75 zx-border-gray-top-v-v-light" [class.zx-low-opp]="isDarkMode"></div>

        <!-- Privacy Policy + Set Theme -->
        <button mat-flat-button aria-label="Privite Policy" (click)="goToPP()"
          class="w-100 d-flex justify-content-center align-items-center">
          <div class="w-100 d-flex align-items-center justify-content-center gap-1 gap-sm-2">
            <span class="zx-text-tiny opacity-75">
              {{'main-nav.p-p' | translate}}
            </span>
          </div>
        </button>

        <span style="height: 10px;"></span>
        <span *ngIf="isIphone()" style="height: 80px;"></span>
      </div>

    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content [class.zx-no-scroller]="isHomePage()" style="overflow-x: hidden;">
    <mat-toolbar [class.zx-bg-gray-light-light-light]="isHomePage()" [ngClass]="{'transparent-toolbar': isHomePage()}"
      style="z-index: 3;" [class.zx-100-opp]="isRootScreen">

      <button class="mat-icon-hanburger-con" mat-icon-button type="button" aria-label="Toggle sidenav"
        (click)="toggleDrawer()">
        <mat-icon class="mat-icon-hanburger" aria-label="Side nav toggle icon">menu</mat-icon>
      </button>

      <span class="spacer d-lg-none"></span>

      <div class="d-flex align-items-center gap-2 zx-flex-grow-lg-1 justify-content-lg-center mx-lg-2">
        <img (click)="goToHome()" *ngIf="userName !== ''" src="assets/images/eazix-logo-small.svg" alt="Eazix Logo"
          class="d-flex d-md-none small-logo c-pointer mx-2">
        <img (click)="goToHome()" *ngIf="userName !== ''" src="assets/images/eazix-logo.png" alt="Eazix Logo"
          class="d-none d-md-flex eazix-logo c-pointer mx-2">
        <img (click)="goToHome()" *ngIf="userName === ''" src="assets/images/eazix-logo.png" alt="Eazix Logo"
          class="d-flex eazix-logo c-pointer mx-2">

        <span *ngIf="userName !== ''" class="zx-text-tiny text-green px-lg-3" [class.zx-rtl]="isRTL">
          <span>{{ 'main-nav.greeting.' + greeting | translate }}, </span>
          <span class="d-lg-none">
            <b>
              {{ userName | slice:0:8 }}
            </b>
            <span *ngIf="userName.length > 8">
              ...
            </span>
          </span>
          <span class="d-none d-lg-inline">
            <b>
              {{ userName | slice:0:30 }}
            </b>
            <span *ngIf="userName.length > 30">
              ...
            </span>
          </span>
        </span>
        <span class="zx-text-tiny zx-text-pink c-pointer d-none d-lg-inline"
          *ngIf="userName !== '' && numOfPoints && numOfPoints > 0" (click)="goToNewOrder()">
          <span>{{ "my-profile.you-have" | translate }}</span>
          <span class="zx-100-opp">-</span>
          <span>{{ numOfPoints }}</span>
          <span class="zx-100-opp">-</span>
          <span>{{ "my-profile.eazix-points" | translate }}</span>
        </span>
      </div>

      <span class="spacer d-lg-none"></span>

      <div class="d-flex align-items-center gap-2 h-100">

        <button *ngIf="userIsAuthenticated" class="d-none d-sm-flex zx-text-tiny zx-bg-gray-light" mat-flat-button
          (click)="goToMyOrders()" [class.num-pending-btn]="userIsAuthenticated && numOfPendingOrders > 0">
          <div class="position-relative" [class.fw-bold]="userIsAuthenticated && numOfPendingOrders > 0">
            <span [class.num-pending-text]="userIsAuthenticated && numOfPendingOrders > 0 && !isDarkMode">
              {{'main-nav.my-orders' | translate }}
            </span>
            <span class="num-pending-con position-absolute" [class.num-pending-con-not-rtl]="!isRTL"
              *ngIf="userIsAuthenticated && numOfPendingOrders > 0">
              <span class="num-pending">
                <span *ngIf="isRTL">
                  {{ numOfPendingOrders < 9 ? numOfPendingOrders : '9+' }} </span>
                    <span *ngIf="!isRTL">
                      {{ numOfPendingOrders < 9 ? numOfPendingOrders : '+9' }} </span>
                    </span>
                </span>
          </div>
        </button>

        <button *ngIf="userIsAuthenticated" class="d-none d-md-flex zx-text-tiny zx-bg-gray-light" mat-flat-button
          (click)="goToNewOrder()">
          <div class="d-flex align-items-center gap-2">
            <mat-icon class="text-green zx-text-small zx-small-tiny-icon-size"
              style="font-size: 16px !important">add_circle_outline</mat-icon>
            <span class="text-green fw-bold">
              {{ 'main-nav.new-order' | translate }}
            </span>
          </div>
        </button>

        <div class="h-100 d-flex align-items-center">

          <button *ngIf="userName === '' && !isLoggedOutLoading" type="button" mat-raised-button color="primary"
            class="zx-small-tiny-btn text-white rounded-3" (click)="openLoginDialog()">
            {{'main-nav.log-in' | translate}}
          </button>

          <div *ngIf="userName !== ''" class="h-100 d-flex align-items-center c-pointer position-relative"
            (click)="toggleProfileManu()">
            <div class="h-100 d-flex align-items-center c-pointer">
              <mat-icon *ngIf="!isProManuOpen" class="zx-tiny-arrow-size"
                (click)="$event.stopPropagation(); toggleProfileManu()">arrow_drop_down</mat-icon>
              <mat-icon *ngIf="isProManuOpen" class="zx-tiny-arrow-size"
                (click)="$event.stopPropagation(); toggleProfileManu()">arrow_drop_up</mat-icon>


              <div class="position-relative" [class.fw-bold]="userIsAuthenticated && numOfPendingOrders > 0">
                <img class="rounded-circle svg zx-profile-default" [src]="getUserProfileImg(user)"
                  alt="Default Profile Image">
                <span class="num-pending-profile-con d-sm-none position-absolute"
                  [class.num-pending-profile-con-not-rtl]="!isRTL"
                  *ngIf="userIsAuthenticated && numOfPendingOrders > 0">
                  <span class="num-pending">
                    <span *ngIf="isRTL">
                      {{ numOfPendingOrders < 9 ? numOfPendingOrders : '9+' }} </span>
                        <span *ngIf="!isRTL">
                          {{ numOfPendingOrders < 9 ? numOfPendingOrders : '+9' }} </span>
                        </span>
                    </span>
              </div>

            </div>
            <div class="overlay-manu" *ngIf="isProManuOpen"></div>
            <div class="position-absolute" *ngIf="isProManuOpen">
              <div class="position-relative">
                <div class="zx-profile-manu rounded-3 step-item" [class.zx-profile-manu-rtl]="isRTL"
                  [class.zx-profile-manu-dark]="isDarkMode">

                  <button class="justify-content-start d-md-none rounded-top-3" mat-menu-item (click)="goToNewOrder()">
                    <div class="d-flex align-items-center gap-2">
                      <mat-icon class="text-green zx-text-small zx-small-tiny-icon-size m-0"
                        style="font-size: 16px !important">add_circle_outline</mat-icon>
                      <span class="zx-text-small text-green fw-bold">
                        {{ 'main-nav.new-order' | translate }}
                      </span>
                    </div>
                  </button>

                  <button *ngIf="userIsAuthenticated" class="justify-content-start d-sm-none" mat-menu-item
                    (click)="goToMyOrders()">
                    <div class="d-flex align-items-center justify-content-center gap-2">
                      <span class="mat-list-item-small" [class.fw-bold]="userIsAuthenticated && numOfPendingOrders > 0"
                        [class.num-pending-text]="userIsAuthenticated && numOfPendingOrders > 0 && !isDarkMode">
                        {{'main-nav.my-orders' | translate }}
                      </span>
                      <span class="num-pending-con" [class.num-pending-con-not-rtl]="!isRTL"
                        *ngIf="userIsAuthenticated && numOfPendingOrders > 0">
                        <span class="num-pending">
                          <span *ngIf="isRTL">
                            {{ numOfPendingOrders < 9 ? numOfPendingOrders : '9+' }} </span>
                              <span *ngIf="!isRTL">
                                {{ numOfPendingOrders < 9 ? numOfPendingOrders : '+9' }} </span>
                              </span>
                          </span>
                    </div>
                  </button>

                  <button *ngIf="userName !== '' && numOfPoints && numOfPoints > 0"
                    class="justify-content-start d-lg-none" mat-menu-item (click)="goToNewOrder()">
                    <span class="mat-list-item-small c-pointer fw-bold" [class.zx-text-pink]="!isDarkMode"
                      [class.text-white]="isDarkMode">
                      <span>{{ "my-profile.use" | translate }}</span>
                      <span class="zx-100-opp">-</span>
                      <span>{{ numOfPoints }}</span>
                      <span class="zx-100-opp">-</span>
                      <span>{{ "my-profile.eazix-points" | translate }}</span>
                    </span>
                  </button>

                  <button class="justify-content-start rounded-sm-top-3" mat-menu-item (click)="goToMyProfile()">
                    <span class="mat-list-item-small">
                      {{'main-nav.my-profile' | translate}}
                    </span>
                  </button>

                  <button class="justify-content-start" mat-menu-item (click)="goToMyProfileCreditMode()">
                    <span class="mat-list-item-small">
                      {{'main-nav.methods-of-payment' | translate}}
                    </span>
                  </button>

                  <hr class="m-1">

                  <button class="justify-content-start rounded-bottom-3" mat-menu-item (click)="onLogout()">
                    <span class="mat-list-item-small" [class.zx-text-warn]="!isDarkMode">
                      {{'main-nav.logout' | translate}}
                    </span>
                  </button>

                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </mat-toolbar>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>